<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myclass" id="تقبل-الاختلاف">
<h1><span dir="rtl">تقبل الاختلاف</span></h1>
<div class="section level2" id="accept-the-difference">
<h2>Accept the Difference</h2>
<p><span dir="rtl">ضع هذا دائماً في عقلك: لا يهم أن نمتلك نفس الفكرة أو الرأي، الأهم أن تستمع لي وأن تفهم، لا أن تتبنى نفس الفكرة.</span></p>
<p><span dir="rtl">احترم اعتقاداتي وأفكاري، ما أحب وما أكره، من أكون وما أريد أن أكون.</span></p>
<p><span dir="rtl">وإن رأيت شيئاً خاطئاً؛ استخدم بعض السحر الذي يُدعى بـ "الأسلوب".</span></p>
<p><span dir="rtl">ولا تنسَ كونك بشرياً وعليك احترام كُل ما يقدم لك، لأنك لا تُريد أن تقلل من قيمة نفسك، لرؤيتك فقط شخصٌ يفعل هذا.</span></p><br/>
<p style="text-align:center; direction:ltr">Put this in your head, it doesn’t matter if you had the same ideas or opinions, what does matter is to listen and understand, not have the same minds. Respect my belief and my mind, what I like and I hate, who I’m and who I want to be. And if you see something wrong use some magic that we called behavior.</p>
<p style="text-align:center; direction:ltr">And do not forget that you’re a human and you have to respect all that offers to you, because you do not want to reduce the value of yourself.</p><br/>
<br/><p style="text-align:center">******</p><br/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?66ceabdf